import { Text } from '@/decodo/components/atoms/Text';
import IconShield from '~/svg/IconShield.svg';

export function MoneyBack({ text }: { text: string }) {
  return (
    <div className='flex items-center gap-2'>
      <IconShield className='text-success-500 h-4 w-4' />
      <Text variant='body-m' color='gray-500'>
        {text}
      </Text>
    </div>
  );
}
